import { Button, ButtonProps, buttonClasses } from '@mui/material';
import React, { FC } from 'react';
import { transition } from 'src/theme';

const ChipButton: FC<ButtonProps> = ({ sx, children, ...props }) => {
  return (
    <Button
      variant="outlined"
      sx={{
        p: ({ spacing }) => spacing(0.5, 2),
        height: 'fit-content',
        borderRadius: 20,
        fontSize: 12,
        transition: transition({ duration: 0.4 }),
        // background: ({ palette }) =>
        //   isOpen ? alpha(palette.primaryLight80 ?? '', 0.25) : 'transparent',
        // '&:hover': {
        //   background: ({ palette }) =>
        //     isOpen ? alpha(palette.primaryLight80 ?? '', 0.25) : 'transparent',
        // },
        [`& .${buttonClasses.endIcon}`]: {
          margin: 0,
          marginRight: 1,
        },
        ...sx,
      }}
      color="inherit"
      dir="rtl"
      {...props}
    >
      {children}
    </Button>
  );
};

export default ChipButton;
